import { RULE_TYPE } from 'fela-utils';
// @ts-ignore
import _Stylis from 'stylis';
// `stylis@3` is a CJS library, there are known issues with them:
// https://github.com/rollup/rollup/issues/1267#issuecomment-446681320
var Stylis = _Stylis.default || _Stylis;

// We use Stylis only for vendor prefixing, all other capabilities are disabled
var stylis = new Stylis({
  cascade: false,
  compress: false,
  global: false,
  keyframe: false,
  preserve: false,
  semicolon: false
});
export var felaStylisEnhancer = function felaStylisEnhancer(renderer) {
  var existingEmitChange = renderer._emitChange.bind(renderer);
  renderer._emitChange = function (change) {
    if (change.type === RULE_TYPE) {
      var prefixed = stylis('', change.declaration);

      // Fela uses objects by references, it's safe to override properties
      change.declaration = prefixed.slice(1, -1);
    }
    existingEmitChange(change);
  };
  return renderer;
};
//# sourceMappingURL=felaStylisEnhancer.js.map
